export default "__VITE_ASSET__DEYI2uDH__"